import { render, staticRenderFns } from "./uploadList.vue?vue&type=template&id=0525ab2c"
import script from "./uploadList.vue?vue&type=script&lang=js"
export * from "./uploadList.vue?vue&type=script&lang=js"
import style0 from "./uploadList.vue?vue&type=style&index=0&id=0525ab2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports